/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum UserRewardStatus {
  Active = 'Active',
  Claimed = 'Claimed',
  Expired = 'Expired',
}
